import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { customerApi } from "../lib/customerApi";
import { useCustomer } from "../contexts/CustomerContext";
import { toast } from "sonner";

const AuthCallback = () => {
  const nav = useNavigate();
  const { refresh } = useCustomer();
  const processed = useRef(false);

  useEffect(() => {
    // Idempotent — StrictMode-safe
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/");
      return;
    }
    const session_id = match[1];

    (async () => {
      try {
        await customerApi.post("/auth/session", { session_id });
        await refresh();
        toast.success("Signed in");
        nav("/account", { replace: true });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Sign-in failed");
        nav("/", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen grid place-items-center text-[#d4af37] font-mono tracking-[0.3em] text-xs uppercase">
      Signing you in…
    </div>
  );
};

export default AuthCallback;
